import qs from 'qs';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { addIcon, coachesIcon, courtsIcon, inviteIcon, playersIcon, writeIcon, cancelIcon, clearIcon, applyIcon } from '../../../../utils/icons';

import styles from './Tabs.module.scss';

type Props = {
    variant: string,
    title?: {
        tab1: string,
        tab2: string,
        tab3: string,
    },
    onButtonOne?: () => void,
    onButtonTwo?: () => void,
    onButtonThree?: () => void,
};

export default function Tabs({ variant, title, onButtonOne, onButtonTwo, onButtonThree }: Props) {
    const history = useHistory();

    return (
        <div className={styles.tabsContainer}>
            {(variant === 'search' || variant === 'calendar') && (
                <>
                    <div className={styles.tabsControlsContainer} onClick={() => history.push('/search?mode=players')}>
                        <div className="icon" style={{ backgroundImage: `url(${playersIcon})` }}/>
                        <span className="icon-text">Players</span>
                    </div>
                    <div className={styles.tabsControlsContainer} onClick={() => history.push('/search?mode=coaches')}>
                        <div className="icon" style={{ backgroundImage: `url(${coachesIcon})` }}/>
                        <span className="icon-text">Coaches</span>
                    </div>
                    <div className={styles.tabsControlsContainer} onClick={() => history.push('/search?mode=courts')}>
                        <div className="icon" style={{ backgroundImage: `url(${courtsIcon})` }}/>
                        <span className="icon-text">Courts</span>
                    </div>
                </>
            )}

            {(variant === 'courts' || variant === 'players') && (
                <>
                    <div className={styles.tabsControlsContainer} role="presentation">
                        <div className="icon" style={{ backgroundImage: `url(${writeIcon})` }}/>
                        <span className="icon-text">Write</span>
                    </div>
                    <div className={styles.tabsControlsContainer} onClick={onButtonTwo} role="presentation">
                        <div className="icon" style={{ backgroundImage: `url(${addIcon})` }}/>
                        <span className="icon-text">{title?.tab2 || 'Add'}</span>
                    </div>
                    <div className={styles.tabsControlsContainer} role="presentation">
                        <div className="icon" style={{ backgroundImage: `url(${inviteIcon})` }}/>
                        <span className="icon-text">Invite</span>
                    </div>
                </>
            )}

            {(variant === 'filters') && (
                <>
                    <div className={styles.tabsControlsContainer} onClick={onButtonOne} role="presentation">
                        <div className="icon" style={{ backgroundImage: `url(${cancelIcon})` }}/>
                        <span className="icon-text">Back</span>
                    </div>
                    <div className={styles.tabsControlsContainer} onClick={onButtonTwo} role="presentation">
                        <div className="icon" style={{ backgroundImage: `url(${clearIcon})` }}/>
                        <span className="icon-text">Remove Filters</span>
                    </div>
                    <div className={styles.tabsControlsContainer} onClick={onButtonThree} role="presentation">
                        <div className="icon" style={{ backgroundImage: `url(${applyIcon})` }}/>
                        <span className="icon-text">Apply</span>
                    </div>
                </>
            )}
        </div>
    );
}
